import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AgentProvider } from './contexts/AgentContext';
import { Layout } from './components/Layout';
// Import pages
import { AIMapPage } from './pages/AIMapPage';
import { GovernancePage } from './pages/GovernancePage';
import { PolicyPage } from './pages/PolicyPage';
import { AuditTrailPage } from './pages/AuditTrailPage';
import { AIActPage } from './pages/AIActPage';
import { GDPRPage } from './pages/GDPRPage';
import { ImpostazioniPage } from './pages/ImpostazioniPage';
import { ServizioDetailPage } from './pages/ServizioDetailPage';
import { CostManagementPage } from './pages/CostManagementPage';
import { CostManagementDetailPage } from './pages/CostManagementDetailPage';
import { GreenOpsPage } from './pages/GreenOpsPage';
import { ReportPage } from './pages/ReportPage';
import { ProvidersPage } from './pages/ProvidersPage';
import { ProviderDetailPage } from './pages/ProviderDetailPage';
import { FornitoriPage } from './pages/FornitoriPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <AgentProvider data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Layout data-id="element-4" />} data-id="element-3">
            {/* Redirect root to costs (Overview) */}
            <Route index element={<Navigate to="/costs" replace data-id="element-6" />} data-id="element-5" />
            {/* Main Routes */}
            <Route path="canvas" element={<AIMapPage data-id="element-8" />} data-id="element-7" />
            <Route path="servizio/:agentId" element={<ServizioDetailPage data-id="element-10" />} data-id="element-9" />
            <Route path="costs" element={<CostManagementPage data-id="element-12" />} data-id="element-11" />
            <Route path="cost-management" element={<CostManagementDetailPage data-id="element-14" />} data-id="element-13" />
            <Route path="greenops" element={<GreenOpsPage data-id="element-16" />} data-id="element-15" />
            <Route path="reports" element={<ReportPage data-id="element-18" />} data-id="element-17" />
            <Route path="providers" element={<ProvidersPage data-id="element-20" />} data-id="element-19" />
            <Route path="providers/:id" element={<ProviderDetailPage data-id="element-22" />} data-id="element-21" />
            <Route path="users" element={<FornitoriPage data-id="element-24" />} data-id="element-23" />

            {/* Compliance Routes with Submenu */}
            <Route path="compliance" data-id="element-25">
              <Route index element={<Navigate to="/compliance/ai-act" replace data-id="element-27" />} data-id="element-26" />
              <Route path="ai-act" element={<AIActPage data-id="element-29" />} data-id="element-28" />
              <Route path="gdpr" element={<GDPRPage data-id="element-31" />} data-id="element-30" />
              <Route path="audit" element={<AuditTrailPage hideHeader={false} data-id="element-33" />} data-id="element-32" />
            </Route>

            <Route path="impostazioni" element={<ImpostazioniPage data-id="element-35" />} data-id="element-34" />
            {/* Catch all - redirect to costs (Overview) */}
            <Route path="*" element={<Navigate to="/costs" replace data-id="element-37" />} data-id="element-36" />
          </Route>
        </Routes>
      </AgentProvider>
    </BrowserRouter>;
}